var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.9219,
    cy: 22.8389,
    r: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9219 20.3389C25.6833 20.3389 27.9219 18.1003 27.9219 15.3389C27.9219 12.5774 25.6833 10.3389 22.9219 10.3389C20.1605 10.3389 17.9219 12.5774 17.9219 15.3389C17.9219 18.1003 20.1605 20.3389 22.9219 20.3389Z",
    fill: "#001261"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32.9219 29.9639C32.9219 33.0701 32.9219 35.5889 22.9219 35.5889C12.9219 35.5889 12.9219 33.0701 12.9219 29.9639C12.9219 26.8576 17.3994 24.3389 22.9219 24.3389C28.4444 24.3389 32.9219 26.8576 32.9219 29.9639Z",
    fill: "#001261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.2c855724634329dc86cdb25b167c4618.svg";
export { ForwardRef as ReactComponent };